import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

const slick = require('slick-carousel');
require('./splidejs.js')

//slick slider
//find and start each slick slider using data-carousel
jQuery(document).ready($ => {
  const slick = $('*[data-carousel]');
  if (slick.length) {

    slick.each(function(index, el) {
      let config = {
        infinite: false,
        dots: false,
        resetOnResize: false,
      };

      // load with new carousel instead of the current one
      if ($(el).hasClass('splide')) {
        return;
      }

      let customConfig = $(el).data('carousel');

      //get custom configs, if passed
      $(el).removeAttr('data-carousel');

      $.extend(config, customConfig);

      if (config.resetOnResize) {
        if (!$(el).is('.slick-initialized')) {
          $(el).slick(config);
        }
        $(window).on('resize load', (event) => {
          if (!$(el).is('.slick-initialized')) {
            $(el).slick(config);
          }
        });
      } else {
        $(el).slick(config);
      }
    });
  }
});
